import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  Drawer,
  IconButton,
  useMediaQuery,
} from '@material-ui/core';
import { useStyles } from './styles';
import { ReactComponent as IconClose } from '../layout/assets/Close.svg';
import { ReactComponent as IconBack } from '../layout/assets/back.svg';
import { SideDrawerProps } from './interface';
import theme from '../../../style/theme';

const SideDrawer: FC<SideDrawerProps> = ({
  onClose,
  toggleDrawer,
  children,
  ctaLabel,
  showCta,
  ctaSecondary,
  ctaSecondaryCallback,
  ctaDisabled,
  onConfirm,
  onBack,
  showBack = false,
  onScroll,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
    noSsr: true,
  });

  const handleCtaSecondaryCallback = () => {
    onClose();
    if (typeof ctaSecondaryCallback === 'function') {
      ctaSecondaryCallback();
    }
  };

  return (
    <>
      <Drawer
        anchor={isMobile ? 'bottom' : 'right'}
        open={toggleDrawer}
        onClose={onClose}
        PaperProps={{
          onScroll,
        }}
      >
        <Box className={classes.drawerHeader}>
          {showBack && (
            <Box className={classes.backBtnWrapper}>
              <IconButton color="inherit" onClick={() => onBack && onBack()}>
                <IconBack className={classes.icon} />
                {t('v2.global.button_label_goBack')}
              </IconButton>
            </Box>
          )}
          {!showBack && (
            <Box className={classes.closeBtnWrapper}>
              <IconButton color="inherit" onClick={onClose}>
                <IconClose className={classes.icon} />
                {t('v2.global.button_close')}
              </IconButton>
            </Box>
          )}
        </Box>

        <Box id="drawer" className={classes.content}>
          {children}
        </Box>

        {/*  Drawer Footer is ONLY used for Offering Details Drawer */}
        {onConfirm && showCta && (
          <Box className={classes.drawerFooter}>
            {ctaSecondary && (
              <Box
                margin="auto"
                onClick={handleCtaSecondaryCallback}
                className={classes.secondaryCta}
              >
                {ctaSecondary}
              </Box>
            )}
            {ctaLabel && !ctaSecondary && (
              <Box className={classes.ctaWrapper}>
                <Button
                  component="button"
                  variant="contained"
                  color="primary"
                  className={classes.footerButton}
                  onClick={onConfirm}
                  disabled={ctaDisabled}
                >
                  {ctaLabel}
                </Button>
              </Box>
            )}
          </Box>
        )}
      </Drawer>
    </>
  );
};

export default SideDrawer;
